import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthContext, useAuthProvider } from './hooks/useAuth';
import { ThemeProvider } from './contexts/ThemeContext';
import Nav from './components/Nav';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import VehicleGrid from './pages/VehicleGrid';
import Dashboard from './pages/Dashboard';
import Kanban from './pages/Kanban';
import Tags from './pages/Tags';
import Handling from './pages/Handling';
import Changes from './pages/Changes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

function AppInner() {
  const auth = useAuthProvider();
  return (
    <AuthContext.Provider value={auth}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <div className="flex flex-col min-h-screen">
                <Nav />
                <main className="flex-1">
                  <Routes>
                    <Route path="/"          element={<VehicleGrid />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/kanban"    element={<Kanban />} />
                    <Route path="/handling"  element={<Handling />} />
                    <Route path="/tags"      element={<Tags />} />
                    <Route path="/changes"   element={<Changes />} />
                    <Route path="*"          element={<Navigate to="/" replace />} />
                  </Routes>
                </main>
              </div>
            </ProtectedRoute>
          }
        />
      </Routes>
    </AuthContext.Provider>
  );
}

export default function App() {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppInner />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
